import { render, staticRenderFns } from "./FundosMetricas.vue?vue&type=template&id=2b94bea0&scoped=true"
import script from "./FundosMetricas.vue?vue&type=script&lang=js"
export * from "./FundosMetricas.vue?vue&type=script&lang=js"
import style0 from "./FundosMetricas.vue?vue&type=style&index=0&id=2b94bea0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b94bea0",
  null
  
)

export default component.exports